<template>
  <div>
    <search-form @search="onSearch" :fields="['term']" />
    <div class="margin-top-2" v-if="showResult">
      <section class="search-tab-internal-chat-wrap">
        <router-link
          v-for="record in records"
          :key="record.id"
          :to="internalChatLink(record)"
          class="internal-chat-result-item"
        >
          <div class="icon-wrap">
            <fluent-icon icon="chat" :size="14" />
          </div>
          <div class="internal-chat-result-details">
            <h5 class="text-block-title name">
              <span class="pre-text">{{ $t('SEARCH.INTERNAL_CHAT.WITH') }}</span>
              {{ record.other_user.name }}
            </h5>
            <message-content :content="record.content" :search-term="term" />
          </div>
        </router-link>

        <empty-state
          v-if="!uiFlags.isFetching && !records.length"
          :title="$t('SEARCH.INTERNAL_CHAT.EMPTY_STATE')"
        />
        <div v-if="uiFlags.isFetching" class="loader">
          <spinner />
          <span>{{ $t('SEARCH.SEARCHING_STATE') }}</span>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';

import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import MessageContent from './MessageContent';
import SearchForm from './SearchForm';

export default {
  components: {
    Spinner,
    EmptyState,
    MessageContent,
    SearchForm,
  },
  data() {
    return {
      showResult: false,
      term: '',
    };
  },
  computed: {
    ...mapGetters({
      records: 'internalChatSearch/getRecords',
      uiFlags: 'internalChatSearch/getUIFlags',
    }),
  },
  methods: {
    internalChatLink(record) {
      return frontendURL(
        `accounts/${this.$route.params.accountId}/internal-chat/${record.internal_conversation_id}`
      );
    },
    onSearch(data) {
      this.showResult = data !== null;
      if (!data || Object.keys(data).length === 0) {
        this.$store.dispatch('internalChatSearch/clearSearchResults');
        return;
      }
      this.term = data.term;
      this.$store.dispatch('internalChatSearch/search', { term: data.term });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-tab-internal-chat-wrap {
  .loader {
    align-items: center;
    display: flex;
    font-size: var(--font-size-default);
    justify-content: center;
    padding: var(--space-big);
  }
}

.internal-chat-result-item {
  cursor: pointer;
  display: flex;
  padding: var(--space-small);
  border-radius: var(--border-radius-small);

  &:hover {
    background-color: var(--s-25);
  }
}

.icon-wrap {
  width: var(--space-medium);
  height: var(--space-medium);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--w-600);
  border-radius: var(--border-radius-small);
  background-color: var(--w-75);
}

.internal-chat-result-details {
  margin-left: var(--space-small);
  flex-grow: 1;
  min-width: 0;
}

.name {
  margin: 0;
}

.pre-text {
  color: var(--s-600);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-normal);
}
</style>
